import React from "react";
import search from "../assets/search.png";
import { Directoriess } from "./Directoriesarray";
import copy from "../assets/copy.png";
import fb from "../assets/fb.png";
import Form from "react-bootstrap/Form";
import Directoriestabs from "./Directoriestabs";
import { useLocation } from "react-router-dom";
import ModalCompo from "../ModalCompo/ModalCompo";

function Directories() {
  const location = useLocation();

  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <div className="directories_main_div" style={{ width: location.pathname === "/add-website" ? "30%": "100%" }}>
      <ModalCompo show={modalShow} onHide={() => setModalShow(false)} />
        <div
          className={`d-flex gap-2 ${
            location.pathname === "/add-website" ? "justify-content-end" : ""
          }`}
        >
          {location.pathname !== "/add-website" ? (
            <>
              <div style={{ position: "relative" }}>
                <input className="direct_input ps-3" />
                <img src={search} className="search_direct" />
              </div>
              <p className="directories_heading">Directories</p>
            </>
          ) : (
            <button className="ad_btn mb-2" onClick={() => setModalShow(true)}>
              Add Website
            </button>
          )}
        </div>
        <Directoriestabs />
        {Directoriess.map((item) => {
          return (
            <>
              <div className="row mt-2 ">
                <div className="col-lg-8 col-md-8 col-sm-12">
                  <div className="d-flex gap-2 align-items-center flex-wrap justify-content-center">
                    <img style={{ height: "30px", width: "30px" }} src={fb} />
                    <div>
                      <p className="directiries_text">{item.text}</p>
                      <p className="directiries_text1">{item.text1} 4d </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <div className="d-flex gap-2 align-items-center justify-content-center">
                    <img src={copy} />
                    <Form.Check type="switch" id="custom-switch" />
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}

export default Directories;
